<template>
  <div class="page">
    <PageHeader :links="headLinks" />
    <div class="pageMain">
      <el-row>
              <el-col :span="24">
                <el-table :data="tableData" style="width: 100%">
                  <el-table-column
                    prop="remarkId"
                    label="主键"
                    width="60"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.remarkId == 0">新增</span>
                      <span v-if="scope.row.remarkId > 0">{{
                        scope.row.remarkId
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="意见内容">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.remarkContent"
                        placeholder="请输入意见内容"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        width="100%"
                        type="primary"
                        v-if="scope.row.remarkId == 0"
                        @click="insertRow(scope.row)"
                        >确认新增</el-button
                      >
                      <div v-if="scope.row.remarkId > 0">
                        <el-button size="small" @click="updateRow(scope.row)"
                          >更新</el-button
                        >

                        <el-button size="small" @click="delRow(scope.row)"
                          >删除</el-button
                        >
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import remarkApi from "@/api/remark";

export default {
  components: { PageHeader },
  data() {
    return {
      headLinks: [
        { path: "", title: "评审意见配置" },
      ],
      tableData: []
    };
  },
  mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      remarkApi.getList().then((res) => {
        this.tableData = res.data;
        this.tableData.push({
          remarkId: 0,
          remarkContent: ""
        });
      });
    },

    insertRow(row) {
      let model = {
        remarkId: parseInt(row.remarkId),
        remarkContent: row.remarkContent
      };
      remarkApi.insert(model).then((res) => {
        if (res.code == 0) {
          this.$notify({
            title: "成功",
            message: "添加成功",
            type: "success",
          });
          this.loadData();
        } else {
          this.$notify.error({
            title: "错误",
            message: "添加失败" + res.msg,
          });
        }
      });
    },

    updateRow(row) {
      let model = {
        remarkId: parseInt(row.remarkId),
        remarkContent: row.remarkContent
      };
      remarkApi.update(model).then((res) => {
        if (res.code == 0) {
          this.$notify({
            title: "成功",
            message: "更新成功",
            type: "success",
          });
          this.loadData();
        } else {
          this.$notify.error({
            title: "错误",
            message: "更新失败" + res.msg,
          });
        }
      });
    },

    delRow(row) {
      remarkApi.delete(row.remarkId).then((res) => {
        if (res.code == 0) {
          this.$notify({
            title: "成功",
            message: "删除成功",
            type: "success",
          });
          this.loadData();
        } else {
          this.$notify.error({
            title: "错误",
            message: "删除失败" + res.msg,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.cardHeader {
  font-size: 16px;
  font-weight: bold;
}
</style>
